import React from 'react';

const Impressum = () => {
  return (
    <div className="min-h-[calc(100vh-200px)] py-10 px-5 bg-slate-100 dark:bg-slate-900">
      <div className="max-w-4xl mx-auto bg-white dark:bg-slate-800 p-6 sm:p-10 rounded-lg shadow-md">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 dark:text-white mb-8 pb-3 border-b-[3px] border-gold">
          Impressum
        </h1>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            Angaben gemass 5 TMG
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Timm Buse<br />
            Meiereistrasse 6<br />
            24960 Munkbrarup
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            Kontakt
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Telefon: <a href="tel:+4915111187914" className="text-gold hover:underline">+49 1511 1187914</a><br />
            E-Mail: <a href="mailto:info@tmk-it.de" className="text-gold hover:underline">info@tmk-it.de</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            Verantwortlich im Sinne des 18 Abs. 2 MStV
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Timm Buse<br />
            Meiereistrasse 6<br />
            24960 Munkbrarup
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            Haftungsausschluss
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Haftung fur Inhalte
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Als Diensteanbieter sind wir gemass 7 Abs.1 TMG fur eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, ubermittelte oder gespeicherte fremde Informationen zu uberwachen oder nach Umstanden
            zu forschen, die auf eine rechtswidrige Tatigkeit hinweisen.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
            Gesetzen bleiben hiervon unberuhrt. Eine diesbezugliche Haftung ist jedoch erst ab dem Zeitpunkt
            der Kenntnis einer konkreten Rechtsverletzung moglich. Bei Bekanntwerden von entsprechenden
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Haftung fur Links
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Unser Angebot enthalt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb konnen wir fur diese fremden Inhalte auch keine Gewahr ubernehmen. Fur die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
            verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mogliche Rechtsverstosse uberpruft.
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
            einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
            Links umgehend entfernen.
          </p>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Urheberrecht
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfaltigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der
            Grenzen des Urheberrechtes bedurfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur fur den privaten, nicht kommerziellen Gebrauch gestattet.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
            beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
            von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            EU-Streitschlichtung
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Europaische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">
              https://ec.europa.eu/consumers/odr/
            </a>.
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            Verbraucherstreitbeilegung / Universalschlichtungsstelle
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Impressum;
